package com.dignicate.web.domain

import com.dignicate.web.domain.mapToResource
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.StateFlow

/** UseCase to fetch navigation labels */
class GetNavigationLabelsUseCase(
    private val repository: com.dignicate.web.domain.ContentRepository,
    private val lang: com.dignicate.web.domain.Language,
    scope: CoroutineScope = CoroutineScope(Dispatchers.Default)
) {
    private val fetchTrigger = MutableSharedFlow<Unit>(replay = 1)

    val data: StateFlow<com.dignicate.web.domain.Resource<com.dignicate.web.domain.NavigationLabels>> =
        fetchTrigger.mapToResource(
            scope = scope,
            then = { _: Unit -> repository.getNavigationLabels(lang) }
        )

    suspend fun fetch() {
        fetchTrigger.emit(Unit)
    }
}
